import React, { useState, useRef, useImperativeHandle, forwardRef } from "react";
import { Dialog, DialogContent, Typography, CircularProgress } from "@mui/material";

const BACKEND_URL = "https://file-backend.robinseasky.org";

export const jsonTransferHelper = {
    upload: async (data, path = null) => {
        const requestBody = {
            type: "Text",
            validHours: 24,
            text: JSON.stringify(data),
        };
        if (path) {
            requestBody.customId = path;
        }
        const response = await fetch(`${BACKEND_URL}/file/upload`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
            throw new Error(`Failed to upload data: ${response.status} ${response.statusText}`);
        }
        const { path: code } = await response.json();
        return code;
    },
    download: async (code) => {
        let response = null;
        while (!response?.ok) {
            await new Promise(resolve => setTimeout(resolve, 1000));
            response = await fetch(`${BACKEND_URL}/file/download?code=${code}`, {
                method: "GET",
            });
        }
        const { type, ...rest } = await response.json();
        if (type !== "Text") {
            throw new Error(`Failed to download data: ${response.status} ${response.statusText}`);
        }
        return JSON.parse(rest.text);
    }
}


// a button that will upload data, and show a progress bar
const Workspace = forwardRef((props, ref) => {
    const [isUploading, setIsUploading] = useState(false);
    const [code, setCode] = useState(null);

    const handleClose = () => {
        setIsUploading(false);
        setCode(null);
        window.location.href = `/${code}`;
    }

    useImperativeHandle(ref, () => ({
        upload: async (data, path = null) => {
            setIsUploading(true);
            const code = await jsonTransferHelper.upload(data, path);
            setIsUploading(false);
            setCode(code);
        },
    }));

    return (
        <div>
            {isUploading && <div>Uploading...</div>}
            <Dialog open={isUploading}>
                <CircularProgress size="80px" />
            </Dialog>
            <Dialog open={code !== null} onClose={handleClose}>
                <DialogContent>
                    <Typography>Please visit link <a href={`https://bill.robinseasky.org/${code}`}>https://bill.robinseasky.org/{code}</a> on other device.</Typography>
                </DialogContent>
            </Dialog>
        </div>
    )
});

export default Workspace;